export default __webpack_public_path__ + "111c157feb06ba4d0020760c01e89756.png";